import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import Modal from './shared/modal'
import Select from 'react-select';

import { teamsList } from '../services/teams';
import { inviteUser } from "../services/users";

const roleValues = ["coach", "assistant", "viewer", "player"];

export const InviteMemberButton = ({ children, team, onClose, role = 'coach' }) => {
  const [errors, setErrors] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invite, setInvite] = useState({ email: '', role, name });
  const [selectedTeam, setSelectedTeam] = useState(team);
  const [teams, setTeams] = useState([]);

  const { t } = useTranslation();

  const roles = roleValues.map(r => ({ value: r, label: t(`roles.${r}`)}) )

  useEffect(() => { setSelectedTeam(team)}, [team]);

  useEffect(() => { 
    if (!!team) {
      return;
    }

    const getMyTeams = async () => {
      const { teams } = await teamsList();
      setTeams(teams);
    };

    getMyTeams();
  }, []);

  const open = () => {
    setInvite({...invite, role})
    setShow(true)
  }

  const save = async () => {
    setLoading(true)
    setErrors([])

    try {
      await inviteUser({...invite, team_id: selectedTeam?.id});
      close(true)
    } catch (e) {
      if (e?.response?.data?.errors) setErrors(e?.response?.data?.errors);
    }
    setLoading(false)
  }

  const close = (reload) => {
    setShow(false);
    setInvite({ email: '', name: '', role });
    onClose && onClose(reload);
  }

  return (
    <>
      <span onClick={open}>{children || <button className="button button-add" >{t('buttons.common.invite-member')}</button>}</span>
      <Modal openModal={show} closeModal={() => setShow(false)}>
        <div className="dialog-content invite-dialog">
          <div>
            <div className='form-group'>
              <label htmlFor="team">{t('coaches.table_team')}</label>
              { !team ?
                <Select
                  id="team"
                  required={true}
                  options={teams.map(t => ({ value: t.id, label: t.name}))}
                  onChange={e => setSelectedTeam(teams.find(t => t.id === e.value))}
                  styles={customStyles}
                />
                : <input id="team" type="text" value={team.name} disabled />
              }
            </div>
              
            <div className='form-group'>
              <label htmlFor="role">{t('coaches.table_role')}</label>
              <Select
                  id="role"
                  options={roles}
                  onChange={e => setInvite({...invite, role: e.value})}
                  value={roles.find(option => option.value === invite.role) || null}
                  styles={customStyles}
                />
            </div>
              
            <div className='form-group'>
              <label htmlFor="name">{t('common.table_name')}</label>
              <input
                id="name"
                type="text"
                value={invite.name}
                onChange={e => setInvite({ ...invite, name: e.target.value})}
              />
            </div>

            <div className='form-group'>
              <label htmlFor="email">{t('common.table_email')}</label>
              <input
                id="email"
                type="text"
                value={invite.email}
                required
                onChange={e => setInvite({ ...invite, email: e.target.value})}
              />
            </div>
          </div>
        </div>

        <div>
          { errors.map(message => <p key={message} style={{fontSize: 12}}>{message}</p>) }
        </div>

        <div className='form-container-actions'>
          <div className='flex-end'>
            <button className="button" disabled={loading} onClick={() => close(false)}>{t('buttons.common.cancel')}</button>
            <button className="button button-primary" disabled={loading} onClick={() => save(true)}>{t('buttons.common.invite')}</button>
          </div>
        </div>

      </Modal>
    </>
  )
}

const customStyles = {
  control: (provided, state) => ({ ...provided, border: '1px solid #eee', boxShadow: 'none', height: 45 }),
};